import React from 'react';
import "./Payment.css";
const PaymentNow = () => {
    return (
        <div  className="payment">
            <h1 >Please Payment</h1>
            <br/>
            <h2>You must Pay, Don't Go anywhere payment gateway is coming soon😀</h2>
        </div>
    );
};

export default PaymentNow;